module.exports = {
    Copyright:'Copyright © 2022',
    CopySucceeded:'Copy succeeded',
    play:'Play',
    viewAll:'View all',
    myAccount:'My Account',
    MyGames:'My Games',
    password:'PASSWORD',
    ChangePassword:'Change Password',
    OldPassword:'Old password',
    newPassword:'New password',
    FAQs:'FAQs',
    TC:'Term & Conditions',
    language:'Language',
    Submit:'Submit',
    change:'change',
    English:'English',
    showMore:'Show More',
    Login:'Login',
    Logout:'Log out',
    getCode:'send OTP',
    phoneNumber:'PHONE NUMBER',
    drawPrize:'draw a prize',
    Name:'Name',
    phone:'phone',
    Prize:'Prize',
    missions1:"This is your missions!<br />Should you choose to accept or deny?<br />It's all up to you.<br />The rest is your destiny.",
    missions2:'your missions',
    Save:'Save',
    YourRecords:'Your Records',
    menmberSince:'MEMBER SINCE',
    lastLogin:'LAST LOGIN',
    gamesYouPlay:'GAMES YOU PLAYED',
    playAce:'PLAYER ACE <br />(THIS MONTH)',
    cancel:'cancel',
    Confirm:'Confirm',
    No:'No',
    OK:'OK',
    Yes:'Yes',
    UNSUBSCRIBE:'UNSUBSCRIBE',
    noMore:'Show more',
    more:'More',
    des2:'Are you sure you want to unsubscribe?',
    myPoints:'my points',
    myPointsTips1:'Points will be available for redemption for a total of 6 months.',
    pointHistory:'point history',
    time:'time',
    description:'description',
    points:'points',
    redeemCenter:'redeem center',
    redeemTips1:'Collect points by playing games and redeem the prizes!',
    redeemTips2:'Points will be available for redemption for a total of 6 months.',
    redeemTips3:'Please confirm.The points in your account will be exchanged by the prizes you want to exchange.This action cannot be undone after you confirm.',
    redeemTips4:'The prize you want to exchange is ATOM TOP UP 12,000ks. 6000 points in your account will be exchanged. Do you want to process?',
    // redeemTips41 , redeemTips5 是 redeemTips4的分解
    redeemTips41:'The prize you want to exchange is ATOM ',
    redeemTips5:'points in your account will be exchanged. Do you want to process?',
    redeemTips6:'congratulations!',
    redeemTips7:'we are sorry!',

    referralTips1:"Refer your friend! Get 99 points!<br />Playing and Competing with a friend<br />give enjoyness all the time.<br />Let's play together!",
    memberGetMember:'member-get-member',
    referralTips2:'This is your referral ID',
    referralTips3:'This is your friends referral ID',
    playNow:'play now',
    headerTips1:"Play games and let's get the points. If you are a new member, we have for you. Enyou the games and get the rewards.",
    headerTips2:'Your account is already login.',
    FeaturedGames:'Featured Games',
    Populargames:'Popular games',
    cgtips1:'To continue, please confirm the subscription to the service which costs 200 Kyats per day and 750 Kyats per 3 days.',
  // cgtips1:'To continue, pls confirm subscribe the service<span class="fs46"> 550 Inc Tax.</span> ',
    cgtips2:'To Unsusbcribe anytime free Dial *1414#',
    cgtips3:'I have read and accept',
    cgtips4:' I acknowledge that above service will be charged to my mobile account',
    Scores:'Scores',
    Status:'Status',
    cgtipsdaily:'To continue, pls confirm subscribe the service 200 Kyats per day. ',
    cgtipsweek:'To continue, pls confirm subscribe the service 750 Inc Tax.',
    noFound:'Ooops! <br />Found no results!',
    TCtitile:"<strong>ATOM generic Terms & Conditions</strong><br />",
    hang1:"<span>•The service will be eligible to use for 365 days with daily/ weekly/ monthly installment fees based on the service typed you choose.</span>",
    hang2:"<span>•The ATOM collected fees for the use of service usage frequency for a time (for example, non renewal or daily, and there is no charge) or installment billing method ( eg weekly /monthly charge based on 365 days of the service may be).</span>",
    hang3:"<span>•If the ATOM's partner (third party) would provide/ serve the trial period for their service, customer can enjoy the trial period till the expiry date. Then, we may charge based on your chosen service even after the trial period is expired. And you will get charged from your mobile balance for the daily/ weekly/ monthly service fees after the trial period is end.</span>",
    hang4:"<span>•Confirm that access the service due to these Terms of Service fees apply for recognition and acceptance confirmation.</span>",
    hang5:'<span>•By clicking subscription you are accepting the Terms and Condition of the Service used.</span>',
    phone_error:'Please enter the phone number',
    re_sub_tip:'You have unsubscribed ?',
    subscribe:'subscribe',
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js